import * as w from '@packages/systems/wfdl';

import {DisplayBlockSmallIcon, CssPreviewIcon} from '@packages/systems/spring';
import {RuntimePropsType} from './datatypes/RuntimeProps';
import {SlotType} from './datatypes/Slot';
import {SlotMigrationContext} from './slot-migration/SlotMetaUI';

/**
 * Webflow plugin containing things relevant only for when DevLink is enabled.
 */
export const plugin = w.Plugins.PrivilegedPlugin({
  dataTypes: {
    RuntimeProps: RuntimePropsType,
    Slot: SlotType,
  },

  icons: {
    RuntimeProps: CssPreviewIcon,
    Slots: DisplayBlockSmallIcon,
  },
});

export {SlotMigrationContext};
